export const styles = {
	attendeeDetails: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px',
		marginBottom: '24px',
		padding: '16px 20px 0',

		'@media (min-width: 768px)': {
			display: 'none',
		},
	},

	block: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
	},

	text: {
		color: 'var(--neutral-300)',
	},

	description: {
		fontWeight: '700',
	},

	container: {
		padding: '0 24px',

		'@media (max-width: 639.98px)': {
			padding: '0 20px',
		},
	},

	table: {
		maxWidth: '896px',
		tableLayout: 'fixed',
	},

	tableHeader: {
		borderRadius: '8px !important',

		'& > :nth-of-type(1)': {
			width: '80%',
			textTransform: 'capitalize',
		},

		'& > :nth-of-type(2)': {
			width: '20%',
			textTransform: 'capitalize',
		},
	},

	tableBody: {
		'& td': {
			paddingY: '12px !important',
		},

		'& > :nth-of-type(1)': {
			width: '80%',
		},
		'& > :nth-of-type(2)': {
			width: '20%',
			textTransform: 'capitalize',
		},
	},
	bodyCell: {
		display: 'flex',
		gap: '12px',
	},

	bodyCellImage: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		background: 'var(--neutral-100)',
		width: '48px',
		height: '48px',
		flexShrink: 0,
		borderRadius: '4px',

		svg: {
			height: '24px',
			width: '24px',

			path: {
				fill: 'var(--neutral-300)',
			},
		},

		marginLeft: '-8px',
		'& img': {
			width: '48px !important',
			height: '48px !important',
			borderRadius: '4px',
		},
	},
	bodyCellImageContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},

	bodyCellImageContentName: {
		fontWeight: '700 !important',
	},

	bodyCellImageContentCategory: {
		color: 'var(--neutral-300) !important',
	},

	menuItem: {
		width: '100%',
		padding: '8px 16px',
		cursor: 'pointer',
		position: 'absolute',
		top: '0',
		right: '0',

		'&:hover': {
			backgroundColor: 'var(--background-grey-op-50-1)',
		},
	},

	tableActionEntryMenu: {
		display: 'flex',
		flexDirection: 'column',
		gap: '40px',
		padding: '16px 0 46px',
	},

	drawerHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: '12px 20px',
	},

	drawerTitle: {
		fontWeight: '700',
		fontSize: '20px',
		lineHeight: '24px',
	},
};
